import AnimatedSection from '../common/AnimatedSection'
import { servicesProcessSection, servicesWorkProcess } from '../../data/servicesPageData'

function ServicesProcess() {
  const { eyebrow, titleLine1, titleAccent, titleLine2, description } = servicesProcessSection

  return (
    <AnimatedSection className="services-process-section">
      <div className="container corp-container">
        <header className="services-section-header services-section-header--center">
          <span className="section-label">{eyebrow}</span>
          <h2>
            {titleLine1}{' '}
            <span>{titleAccent}</span>
            <br />
            {titleLine2}
          </h2>
          <p>{description}</p>
        </header>

        <div className="services-process-timeline" role="list">
          {servicesWorkProcess.map((item, index) => (
            <article className="services-process-step" key={item.step} role="listitem">
              <div className="services-process-step__marker">
                <span className="services-process-step__num">{item.step}</span>
                {index < servicesWorkProcess.length - 1 ? (
                  <span className="services-process-step__line" aria-hidden="true" />
                ) : null}
              </div>
              <div className="services-process-step__body">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ServicesProcess
